<template>
    <div class="card card-admin">
        <div class="newProduct-title">
            <h1>Aggiungi un nuovo piatto</h1>
        </div>
        <div class="card-body">
            <div class="form-group">
                <img class="img-thumbnail image-preview" :src="editedProduct.image_url" v-if="editedProduct.image_url"
                    alt="Anteprima immagine" />
                <p style="text-align: center;" v-else>Anteprima immagine non disponibile</p>
            </div>
            <div class="form-group">
                <label for="name">Nome prodotto:</label>
                <input type="text" class="form-control" id="name" v-model="editedProduct.name"
                    placeholder="Inserisci il nome del prodotto">
            </div>
            <div class="form-group">
                <label for="description">Descrizione:</label>
                <textarea class="form-control" id="description" v-model="editedProduct.description"
                    placeholder="Inserisci la descrizione del prodotto"></textarea>
            </div>
            <div class="form-group">
                <label for="price">Prezzo:</label>
                <input type="number" class="form-control" id="price" v-model="editedProduct.price"
                    placeholder="Inserisci il prezzo del prodotto">
            </div>
            <div class="form-group">
                <label for="category">Categoria</label>
                <input type="text" class="form-control" id="category" v-model.trim="editedProduct.category"
                    placeholder="Inserisci la categoria">
            </div>
            <div class="form-group">
                <ImageUploader @image-selected="handleFileSelected"></ImageUploader>
            </div>

            <div class="button-group">
                <button class="btn btn-primary apply-button" @click="handleCreateNewProduct">Aggiungi nuovo
                    piatto</button>
            </div>
        </div>
    </div>
</template>

<script>
import { createDish } from '@/api/DishesAPI';
import { uploadImage } from '@/utils/firebaseImageUploader';
import ImageUploader from '@/components/adminpage/ImageUploader.vue';

export default {
    components: {
        ImageUploader,
    },
    data() {
        return {
            editedProduct: { ...this.product },
        };
    },
    methods: {
        handleFileSelected(file) {
            this.editedProduct.image_url = file;
        },
        async handleCreateNewProduct() {
            try {
                if (this.editedProduct.image_url) {
                    const imageurl = await uploadImage(this.editedProduct.image_url);
                    this.editedProduct.image_url = imageurl;
                }
                await createDish(this.editedProduct);
                this.$emit('new-product-created');
            } catch (error) {
                console.error('Errore durante la creazione del nuovo prodotto:', error);
            }
        }
    }
};
</script>

<style scoped>
.card-admin {
    padding-top: 30px;
    border: none;
    background-color: transparent;
    margin: 20px;
    margin-bottom: 0px;
    padding-bottom: 30px;
}

.form-group {
    margin-bottom: 20px;
    padding-left: 15px;
    padding-right: 15px;
}

.apply-button,
.delete-button {
    margin: auto;
}

.image-preview {
    max-width: 100%;
    height: auto;
    display: block;
    margin: auto;
}

.card-body {
    color: var(--text-color);
    background-color: var(--secondary-color);
    box-shadow: var(--custom-box-shadow);
    border-radius: 20px;
}

.button-group {
    display: flex;
    margin-top: 40px;
    margin-bottom: 15px;
}

.newProduct-title {
    color: var(--text-color);
    background-color: var(--accent-color);
    text-align: center;
    margin: auto;
    margin-bottom: 20px;
    border-radius: 25px;
    border: solid 2px;
    border-color: var(--border-color);
    box-shadow: var(--custom-box-shadow);
}

.newProduct-title h1 {
    padding: 10px;

}
</style>